
/* injects from baggage-loader */
var Template = require('./template.js');

import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from 'lodash';
import Event from "../event";
import { getMarketDataByKey } from "../../../helpers/markets";
import Config from "../../../config/main";

const isInt = n => Number(n) === n && n % 1 === 0;

const isMarketDataPassTheFilter = (marketData, filter) => {
    if (marketData.base && isInt(+marketData.base))
        return false;

    const dynamicFilterableKeys = Object.keys(marketData);

    const everyFilterPassed = dynamicFilterableKeys.every(key => {
        const filterForCurrentKey = filter[key];

        if (filterForCurrentKey === undefined)
            return true;

        if (typeof filterForCurrentKey === 'object')
            return filterForCurrentKey['@in'].includes(marketData[key].toString());

        return filterForCurrentKey.toString() === marketData[key].toString();
    });

    return everyFilterPassed;
};

const findProperty = (marketsObj, filter) => {
    for (const key in marketsObj) {
        const marketData = getMarketDataByKey(key);

        if (isMarketDataPassTheFilter(marketData, filter))
            return key;
    }
}

class AsianGameEvent extends Component {
    render() {
        let { item, game, group, gameType, boostedOdds } = this.props;
        try {
            let events = {}, eventsObj = {};

            const marketKey = findProperty(game.groupedMarkets, { ..._.omit(item, ['title', 'side']), group });
            const market = game.groupedMarkets[marketKey];
            // if (item.base === 'all') {
            //     market = game.groupedMarkets[findPropertyNameByRegex(game.groupedMarkets, new RegExp(`${groups}_${item.display_key}_(\d|\.)+`))];
            // } else {
            //     market = game.groupedMarkets[groups + "_" + item.display_key + "_" + (item.base || '')];
            // }
            eventsObj = market.event;
            eventsObj && Object.keys(eventsObj).map(id => {
                events[eventsObj[id].type] = eventsObj[id];
            });
            let closedEventClass = !events[item.side] ? ' closedEvent ' : '';
            return <li className={`factor-m ${closedEventClass} ${item.display_key}`} key={item.market}><Event key={group} showBase event={events[item.side]}
                price={events[item.side] && events[item.side].price}
                gameType={gameType}
                game={game} market={market} boostedOdds={boostedOdds !== undefined && boostedOdds} /></li>;
        } catch (e) {
            return <li className="factor-m empty" key={item.market}>{ Config.emptyEventLines && <span className='empty-event' /> }</li>;
        }
    }
}

AsianGameEvent.propTypes = {
    game: PropTypes.object,
    item: PropTypes.object,
    group: PropTypes.string,
};

export default AsianGameEvent;
